import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import BannerPortalContext from './BannerPortalContext';
import Button from './Button';
import { Brands } from './../common/constants';

const Container = styled.div`
  ${(props) => `
    text-align: center;
    background: ${props.theme.colours.banner.background};
    padding: ${props.theme.whitespace.small};
  `}
`;

const Wrap = styled.div`
  max-width: 700px;
  margin: auto;
`;

const Primary = styled.div`
  ${(props) => `
    color: ${props.theme.colours.banner.primary};
    font-weight: 500;
    margin: 0;
    &:last-child {
      margin-bottom: 0;
    }
    text-align: inherit;
  `}
  ${(props) => props.brand === Brands.Wireless && props.theme.type.optOutPrimary}
`;

const Secondary = styled.div`
  ${(props) => props.theme.type.base};
  ${(props) => props.theme.type.small};
  ${(props) => `
    text-align: inherit;
    color: ${props.theme.colours.banner.secondary};
    margin-bottom: ${props.theme.whitespace.small};
  `};
  ${(props) => props.brand === Brands.Wireless && props.theme.type.optOutSecondary};
`;

const Action = styled(Button)``;

const Banner = ({
  primary = '',
  secondary = '',
  actionLabel = '',
  actionHandler = () => {},
  brand
}) => {
  const target = React.useContext(BannerPortalContext);

  if (!target) {
    return null;
  }

  return createPortal(
    <Container brand={brand} className="banner-container">
      <Wrap className="banner-wrap">
        {primary && <Primary brand={brand} className="banner-primary">{primary}</Primary>}
        {secondary && <Secondary brand={brand} className="banner-secondary">{secondary}</Secondary>}
      </Wrap>
      {actionLabel && <Action className="banner-button" onClick={actionHandler}>{actionLabel}</Action>}
    </Container>,
    target
  );
};

Banner.propTypes = {
  primary: PropTypes.string,
  secondary: PropTypes.string,
  actionLabel: PropTypes.string,
  actionHandler: PropTypes.func,
  brand: PropTypes.string
};

export default Banner;
